module.exports = __webpack_public_path__ + "static/media/mode-60.3ad5a76d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-60.svg
// module id = 1014
// module chunks = 2